export enum ConfirmationRequestType {
    CREATE_APPLICATION_WALLET = 'CREATE_APPLICATION_WALLET',
    CREATE_FIRST_WALLET = 'CREATE_FIRST_WALLET',
    IMPORT_WALLET = 'IMPORT'
}
